/* Utility Function - Open and accordions */

/* Trigger Class = "accordion" */
/* Content must be next direct sibling, with the class "accordion__content" */
var accordion = document.getElementsByClassName("accordion");

for (i = 0; i < accordion.length; i++) {
  accordion[i].addEventListener("click", function() {
    var content = this.nextElementSibling;
    this.classList.toggle("open");
    content.classList.toggle("open");

    if (content.style.maxHeight){
      content.style.maxHeight = content.scrollHeight + "px";
      this.dataset.accordionicon = "+"
      setTimeout(() => {
      content.style.maxHeight = null;
      }, 1);
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      this.dataset.accordionicon = "-"
      setTimeout(() => {
        content.style.maxHeight = "none";
      }, 200);
    } 
  });
}

/* Utility Function - Freeze Body */
freezeBodyToggle = (freezeBody) => {
  body = document.querySelector('body');

  if (freezeBody == false) {
    body.classList.remove('freezeBody');
  } else if (freezeBody == true) {
    body.classList.add('freezeBody');
  }
}

/* Handle auto-playing videos after page has loaded. */
window.addEventListener('load', function () {
  document.querySelectorAll('video').forEach((video) => {
    video.play();
  })
})

function initAjaxinate() {
  var endlessScroll = new Ajaxinate({offset: 200, loadingText: 'Loading Products', method: 'click'});
}

/* Tooltips */
  (function () {
    const TOOLTIP_SELECTOR = "[data-tooltip]";
    let tooltipEl = null;
    let currentTarget = null;

    function createTooltipEl() {
      const el = document.createElement("div");
      el.className = "tooltip";
      document.body.appendChild(el);
      return el;
    }

    function getValign(target) {
      const v = (target.getAttribute("data-valign") || "top").toLowerCase();
      if (v === "middle" || v === "center") return "middle";
      if (v === "bottom") return "bottom";
      return "top";
    }

    function getHalign(target) {
      const h = (target.getAttribute("data-halign") || "center").toLowerCase();
      if (h === "left") return "left";
      if (h === "right") return "right";
      return "center";
    }

    function getBaseTransform(valign, halign) {
      let tx = "-50%";
      let ty = "-100%";

      // Horizontal
      if (halign === "left") tx = "0";
      if (halign === "right") tx = "-100%";

      // Vertical
      if (valign === "top") ty = "-100%";
      if (valign === "middle") ty = "-50%";
      if (valign === "bottom") ty = "0";

      return `translate(${tx}, ${ty})`;
    }

    function positionTooltip(target) {
      if (!tooltipEl) return;

      const rect = target.getBoundingClientRect();
      const valign = getValign(target);
      const halign = getHalign(target);

      let anchorX = rect.left + rect.width / 2;
      let anchorY = rect.top;

      // Vertical anchor
      if (valign === "top") {
        anchorY = rect.top;
      } else if (valign === "middle") {
        anchorY = rect.top + rect.height / 2;
      } else if (valign === "bottom") {
        anchorY = rect.bottom;
      }

      // Horizontal anchor
      if (halign === "left") {
        anchorX = rect.left;
      } else if (halign === "right") {
        anchorX = rect.right;
      }

      tooltipEl.style.left = `${anchorX}px`;
      tooltipEl.style.top = `${anchorY}px`;

      const baseTransform = getBaseTransform(valign, halign);
      tooltipEl.style.setProperty("--tooltip-transform", baseTransform);
    }

    function showTooltip(target) {
      if (!tooltipEl) tooltipEl = createTooltipEl();
      const text = target.getAttribute("data-tooltip");
      if (!text) return;

      currentTarget = target;
      tooltipEl.textContent = text;
      positionTooltip(target);
      tooltipEl.classList.add("tooltip--visible");
    }

    function hideTooltip() {
      if (!tooltipEl) return;
      tooltipEl.classList.remove("tooltip--visible");
      currentTarget = null;
    }

    // Event delegation for hover
    document.addEventListener("mouseover", (e) => {
      const target = e.target.closest(TOOLTIP_SELECTOR);
      if (!target) return;
      showTooltip(target);
    });

    document.addEventListener("mouseout", (e) => {
      const related = e.relatedTarget;
      if (currentTarget && (!related || !currentTarget.contains(related))) {
        hideTooltip();
      }
    });

    // Optional: support keyboard focus
    document.addEventListener("focusin", (e) => {
      const target = e.target.closest(TOOLTIP_SELECTOR);
      if (!target) return;
      showTooltip(target);
    });

    document.addEventListener("focusout", (e) => {
      const target = e.target.closest(TOOLTIP_SELECTOR);
      if (target === currentTarget) {
        hideTooltip();
      }
    });

    // Optional: hide on scroll/resize to avoid misalignment
    window.addEventListener("scroll", () => {
      if (currentTarget) positionTooltip(currentTarget);
    });
    window.addEventListener("resize", () => {
      if (currentTarget) positionTooltip(currentTarget);
    });
  })();